<mat-card [class]="accent" class="mb-2">
  <div class="titulo" class="pb-2 d-flex align-items-center">
    <mat-icon *ngIf="warning" class="mr-2 mat-error" [matTooltip]="warning.tooltip">warning</mat-icon>
    <bdg-label type="subheading-1">{{ titulo }}</bdg-label>
  </div>
  <mat-card-content>
    <ng-content select="[text]"></ng-content>
  </mat-card-content>
  <div class="row justify-content-between align-items-center">
    <div class="col-auto">
      <ng-content select="[chips]"></ng-content>
    </div>
    <div class="col-auto">
      <ng-content select="[buttons]"></ng-content>
    </div>
  </div>
</mat-card>
